import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-height: 340px;
`;

export const ModalDescription = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  min-height: 224px;
  max-height: 224px;
  overflow-y: auto;
`;

export const SkeletonRow = styled.div`
  height: 32px;
  width: 100%;
  display: flex;
  align-items: center;
`;
